// extracted by mini-css-extract-plugin
export default {"message":"freelancer-not-found_message__j0ZCD","info":"freelancer-not-found_info__7Aof5"};